module.exports = __webpack_public_path__ + "static/media/LogoBig.db41e137.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/LogoBig.svg
// module id = 89
// module chunks = 0